<template>
    <div class="col-md-12">
        <div class="ln_solid"></div>
        <br />
        <form @submit.prevent="searchData()" role="form">
            <div class="row">

                <div class="col-2">

                    <input type="date" class="form-control" v-model="pagingInfo.dateStart" placeholder="Date Start" />

                </div>
                <div class="col-2">

                    <input type="date" class="form-control" v-model="pagingInfo.dateEnd" placeholder="Date End" />

                </div>


                <div class="col-2">
                    <select name="ulist" v-model="pagingInfo.userName" class="form-control">
                        <option value>Select Users</option>
                        <option v-for="option in userslist" v-bind:value="option.userName" v-bind:key="option.userName">
                            {{ option.userName }}
                        </option>
                    </select>
                </div>


                <div class="col-2">
                    <button type="submit" class="btn btn-info">
                        <strong>Search</strong>
                    </button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">
                        Clear
                    </button>
                </div>
            </div>
        </form>
        <br />
        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                User
                            </th>
                            <th>
                                Date Downloaded
                            </th>
                            <th>
                                Profile Id
                            </th>
                            <th>
                                File Name
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="doc in profiles" :key="doc.id">
                            <td>{{ doc.downloadedBy | capitalize }}</td>
                            
                            <td>{{ doc.dateDownloaded | soiDate }}</td>
                            <td>{{ doc.entryId }}</td>
                            <td>{{ doc.fileName }}</td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
                <div v-show="totalitems == 0" class="alert alert-warning">
                    <p>Found no result try again</p>
                </div>
            </div>
            <div class="box-footer clearfix">
                <b-pagination v-model="pagingInfo.page" v-on:input="fetchData()" :total-rows="totalitemsprofile" :per-page="pagingInfo.itemsPerPage"
                    first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination>
            </div>
        </div>

    </div>
</template>

<script>
import {
    authHeader,
    responseCheck,
    LogURL,
    getListofUsers,
} from "../helper";
import instance from "../helper/http";
//import ProfileLogs from "./master/downloadLogs.vue";
export default {
    data() {
        return {
            profiles: [],
            pagingInfo: {
                page: 1,
                userName: "",
                dateStart: "",
                dateEnd: "",
                itemsPerPage: 10
            },
            totalitemsprofile: null,
            userslist: [],

        };
    },
    // components: {
    //      btn,
    //      ProfileLogs
    // },

    created: function () {
        this.getUsers();

    },
    methods: {

        fetchData() {
            instance
                .get(LogURL + "getprofilelogsbyuser", {
                    headers: authHeader(),
                    params: this.pagingInfo,
                })
                .then((response) => {
                    this.profiles = response.data.data;
                    this.totalitemsprofile = response.data.count;
                })
                .catch(function (error) {
                    responseCheck(error.response.status);
                });
        },
        searchData() {
            this.pagingInfo.page = 1;
            this.fetchData();
        },

        clearControls() {

            this.pagingInfo.dateStart = "";
            this.pagingInfo.dateEnd = "";

        },
        getUsers() {
            this.userslist = getListofUsers();
        },
    },
};
</script>
